import React from "react"

export default function AddLinesInput() {
  return (
    <div>
      Haven't built this... let me know if you think it would be helpful to
      manually add lines based on GPS
    </div>
  )
}
